import React from "react";


import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import OndemandVideoIcon from "@material-ui/icons/OndemandVideo";
import FilterListIcon from "@material-ui/icons/FilterList";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import PersonIcon from "@material-ui/icons/Person";
import AssignmentIcon from "@material-ui/icons/Assignment";
import ReorderIcon from "@material-ui/icons/Reorder";
import DirectionsCarIcon from "@material-ui/icons/DirectionsCar";
import BarChartIcon from "@material-ui/icons/BarChart";
import MotorcycleIcon from "@material-ui/icons/Motorcycle";
import LibraryAddCheckIcon from "@material-ui/icons/LibraryAddCheck";
import ArrowRightAltIcon from "@material-ui/icons/CallMadeRounded";
import ArrowLeftAltIcon from "@material-ui/icons/CallMadeRounded";
import FolderIcon from "@material-ui/icons/Folder";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import CachedIcon from "@material-ui/icons/Cached";
import SettingsIcon from "@material-ui/icons/Settings";
import MailIcon from "@material-ui/icons/Mail";
import NotificationsIcon from "@material-ui/icons/Notifications";
import CreateIcon from "@material-ui/icons/Create";
import PersonAddRoundedIcon from "@material-ui/icons/PersonAddRounded";
import VpnKeyRoundedIcon from "@material-ui/icons/VpnKeyRounded";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import LocalShippingRoundedIcon from "@material-ui/icons/LocalShippingRounded";
import TodayRoundedIcon from "@material-ui/icons/EventNote";
import TrafficIcon from "@material-ui/icons/Traffic";
import CloudOffIcon from "@material-ui/icons/CloudOff";
import WatchLaterIcon from "@material-ui/icons/WatchLater";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import MapTwoToneIcon from "@material-ui/icons/MapTwoTone";
import RoomRoundedIcon from "@material-ui/icons/RoomRounded";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import HomeRoundedIcon from "@material-ui/icons/HomeRounded";
import CheckBoxOutlineBlankRoundedIcon from "@material-ui/icons/CheckBoxOutlineBlankRounded";
import QueryBuilderRoundedIcon from "@material-ui/icons/QueryBuilderRounded";
import PhoneEnabledRoundedIcon from "@material-ui/icons/PhoneEnabledRounded";
import NotListedLocationIcon from "@material-ui/icons/NotListedLocation";
import SearchIcon from "@material-ui/icons/Search";
import LockIcon from "@material-ui/icons/Lock";
import MenuOpenIcon from "@material-ui/icons/MenuOpen";
import SyncRoundedIcon from "@material-ui/icons/SyncRounded";
import DeleteIcon from "@material-ui/icons/Delete";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListAltRoundedIcon from "@material-ui/icons/ListAltRounded";
import Battery80RoundedIcon from "@material-ui/icons/Battery80Rounded";
import VideocamIcon from "@material-ui/icons/Videocam";
import GroupRoundedIcon from "@material-ui/icons/GroupRounded";
import InfoRoundedIcon from "@material-ui/icons/InfoRounded";
import BackupIcon from "@material-ui/icons/Backup";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import SwapCallsIcon from "@material-ui/icons/SwapCalls";
import PublicIcon from "@material-ui/icons/Public";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import Image from "@material-ui/icons/Image";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import DescriptionIcon from "@material-ui/icons/Description";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import FormatListNumberedRtlIcon from '@material-ui/icons/FormatListNumberedRtl';
import SpellcheckIcon from '@material-ui/icons/Spellcheck';
import Check from '@material-ui/icons/Check';

const styles = { transition: "all linear .2s" };

const getIcon = (icon, localStyle) => {
  const style = { ...styles, ...localStyle };
  switch (icon) {
    case "check":
      return <Check style={style} />;
    case "validated":
      return <SpellcheckIcon style={style} />;
    case "visibility":
      return <Visibility style={style} />;
    case "visibilityOff":
      return <VisibilityOff style={style} />;
    case "description":
      return <DescriptionIcon style={style} />;
    case "table":
      return <FormatListBulletedIcon style={style} />;
    case "download":
      return <CloudDownloadIcon style={style} />;
    case "image":
      return <Image style={style} />;
    case "circle":
      return <FiberManualRecordIcon style={style} />;
    case "public":
      return <PublicIcon style={style} />;
    case "distance":
      return <SwapCallsIcon style={style} />;
    case "merge":
      return <AccountTreeIcon style={style} />;
    case "owner":
      return <AssignmentIndIcon style={style} />;
    case "multiSelect":
      return <LibraryAddCheckIcon style={style} />;
    case "Filter":
      return <FilterListIcon style={style} />;
    case "video":
      return <OndemandVideoIcon style={style} />;
    case "view":
      return <RemoveRedEyeIcon style={style} />;
    case "user":
      return <PersonIcon style={style} />;
    case "info":
      return <InfoRoundedIcon style={style} />;
    case "users":
      return <GroupRoundedIcon style={style} />;
    case "task":
      return <AssignmentIcon style={style} />;

    case "overview":
      return <ReorderIcon style={style} />;

    case "driver":
      return <DirectionsCarIcon style={style} />;

    case "car":
      return <DirectionsCarIcon style={style} />;

    case "analitics":
      return <BarChartIcon style={style} />;

    case "bike":
      return <MotorcycleIcon style={style} />;

    case "arrowRight":
      return (
        <ArrowRightAltIcon
          style={{
            transform: "rotate(45deg)",
            ...style,
          }}
        />
      );

    case "arrowLeft":
      return (
        <ArrowLeftAltIcon
          style={{
            transform: "rotate(225deg)",
            ...style,
          }}
        />
      );

    case "folder":
      return <FolderIcon style={style} />;

    case "upload":
      return <CloudUploadOutlinedIcon style={style} />;

    case "plus":
      return <AddRoundedIcon style={style} />;

    case "add":
      return <CreateNewFolderIcon style={style} />;

    case "show":
      return <FormatListNumberedRtlIcon style={style} />;

    case "setting":
      return <SettingsIcon style={style} />;

    case "mail":
      return <MailIcon style={style} />;

    case "notification":
      return <NotificationsIcon style={style} />;

    case "doneDubble":
      return <DoneAllIcon style={style} />;

    case "done":
      return <CheckRoundedIcon style={style} />;

    case "exit":
      return <ExitToAppIcon style={style} />;

    case "revert":
      return <CachedIcon style={style} />;

    case "pen":
      return <CreateIcon style={style} />;

    case "add-person":
      return <PersonAddRoundedIcon style={style} />;

    case "login":
      return <VpnKeyRoundedIcon style={style} />;

    case "truck":
      return <LocalShippingRoundedIcon style={style} />;

    case "calendar":
      return <TodayRoundedIcon style={style} />;

    case "traffic":
      return <TrafficIcon style={style} />;

    case "cloudOff":
      return <CloudOffIcon style={style} />;

    case "close":
      return <CloseRoundedIcon style={style} />;

    case "watch":
      return <WatchLaterIcon style={style} />;

    case "defaultMarker":
      return <RoomRoundedIcon style={style} />;

    case "map":
      return <MapTwoToneIcon style={style} />;

    case "alert":
      return <WarningRoundedIcon style={style} />;

    case "home":
      return <HomeRoundedIcon style={style} />;

    case "box":
      return <CheckBoxOutlineBlankRoundedIcon style={style} />;

    case "clock":
      return <QueryBuilderRoundedIcon style={style} />;

    case "phone":
      return <PhoneEnabledRoundedIcon style={style} />;

    case "questionMarker":
      return <NotListedLocationIcon style={style} />;

    case "search":
      return <SearchIcon style={style} />;

    case "menu":
      return <MenuOpenIcon style={style} />;

    case "lock":
      return <LockIcon style={style} />;

    case "sync":
      return <SyncRoundedIcon style={style} />;

    case "trash":
      return <DeleteIcon style={style} />;

    case "chevronLeft":
      return <ChevronLeftIcon style={style} />;

    case "chevronRight":
      return <ChevronRightIcon style={style} />;

    case "chevronDown":
      return <KeyboardArrowDownIcon style={style} />;

    case "list":
      return <ListAltRoundedIcon style={style} />;

    case "battery80":
      return <Battery80RoundedIcon style={style} />;

    case "camera":
      return <VideocamIcon style={style} />;

    case "cloudup":
      return <BackupIcon style={style} />;

    default:
      return null;
  }
}

export default getIcon;
